import { Component, OnInit, ViewChild } from '@angular/core';
import { AvtListesComponent } from '../avt-listes/avt-listes.component';
import { ActivatedRoute } from '@angular/router';
import { GeneralService } from '../services/general.service';
import { AvtSuiviePedBulletinNotesComponent } from '../avt-suivie-ped-bulletin-notes/avt-suivie-ped-bulletin-notes.component';
import { MatDialogConfig } from '@angular/material/dialog';
import * as globalUrls from '../services/globalVariables';

@Component({
  selector: 'app-avt-suivie-ped-appreciation',
  templateUrl: './avt-suivie-ped-appreciation.component.html',
  styleUrls: ['./avt-suivie-ped-appreciation.component.scss'],
})
export class AvtSuiviePedAppreciationComponent implements OnInit {
  constructor(
    public route: ActivatedRoute,
    public generalService: GeneralService
  ) {}
  titre: string = '';
  // fenetre = 1 appreciation par matière
  // fenetre = 2 appreciation par période
  // fenetre = 3 appreciation par année
  fenetre: string = '';
  exist: boolean = true;
  listeAllMatiereIsLoadet: boolean = false;
  @ViewChild('listeAppreciationComponen', { static: false })
  listeAppreciationComponen: AvtListesComponent;
  @ViewChild('listeDetailAppreciationComponen', { static: false })
  listeDetailAppreciationComponen: AvtListesComponent;
  dataSourceAppreciation = [
    {
      apprenantsNoteEvaluation:
        "<img src='../../assets/avatar.png' style='width : 60px;margin-right : 10px'> apprenant 1",
      moyenne: '5',
      oldMoyenne: '2',
      appreciation: 'commentaire 1',
    },
    {
      apprenantsNoteEvaluation:
        "<img src='../../assets/avatar.png' style='width : 60px;margin-right : 10px'> apprenant 1",
      moyenne: '15',
      oldMoyenne: '10',
      appreciation: 'commentaire 2',
    },
  ];
  columnsAppreciation = { TableRD: [] };
  //liste colonne pour apréciation par période et matière
  columnsAppreciationMatierePeriode = [
    {
      TableRE_Code: '',
      TableRD_Champs: 'apprenantsNoteEvaluation',
      Lg_Code: '',
      TableRD_Des: 'Apprenants',
      TableRD_Largeur: 150,
      TableRD_ReadOnly: true,
      TableRD_Format: '',
      TableRD_Alligement: 0,
      TableRD_Ordre: 1,
      TableRD_Type: 7,
      TableRD_Param1: null,
      TableRD_Param2: 'number',
      TableRD_ValDef: null,
      TableRD_Tri: true,
      TableRD_Valid: null,
      TableRD_ValidType: 0,
      TableRD_ExpressionH: null,
      TableRD_ExpressionR: null,
      User_Id: '*',
      User_Groupe: null,
    },
    {
      TableRE_Code: '',
      TableRD_Champs: 'moyenne',
      Lg_Code: '',
      TableRD_Des: 'Moyennes',
      TableRD_Largeur: 100,
      TableRD_ReadOnly: false,
      TableRD_Format: '',
      TableRD_Alligement: 0,
      TableRD_Ordre: 6,
      TableRD_Type: 100,
      TableRD_Param1: null,
      TableRD_Param2: 'number',
      TableRD_ValDef: null,
      TableRD_Tri: true,
      TableRD_Valid: null,
      TableRD_ValidType: 0,
      TableRD_ExpressionH: null,
      TableRD_ExpressionR: null,
      User_Id: '*',
      User_Groupe: null,
    },
    {
      TableRE_Code: '',
      TableRD_Champs: 'oldMoyenne',
      Lg_Code: '',
      TableRD_Des: 'Moyennes antérieures',
      TableRD_Largeur: 170,
      TableRD_ReadOnly: true,
      TableRD_Format: '',
      TableRD_Alligement: 0,
      TableRD_Ordre: 7,
      TableRD_Type: 0,
      TableRD_Param1: null,
      TableRD_Param2: 'number',
      TableRD_ValDef: null,
      TableRD_Tri: true,
      TableRD_Valid: null,
      TableRD_ValidType: 0,
      TableRD_ExpressionH: null,
      TableRD_ExpressionR: null,
      User_Id: '*',
      User_Groupe: null,
    },
    {
      TableRE_Code: '',
      TableRD_Champs: 'appreciation',
      Lg_Code: '',
      TableRD_Des: 'Appréciations',
      TableRD_Largeur: 300,
      TableRD_ReadOnly: false,
      TableRD_Format: '',
      TableRD_Alligement: 0,
      TableRD_Ordre: 8,
      TableRD_Type: 0,
      TableRD_Param1: null,
      TableRD_Param2: null,
      TableRD_ValDef: null,
      TableRD_Tri: true,
      TableRD_Valid: null,
      TableRD_ValidType: 0,
      TableRD_ExpressionH: null,
      TableRD_ExpressionR: null,
      User_Id: '*',
      User_Groupe: null,
    },
  ];
  //liste colonne pour apréciation par Année
  columnsAppreciationAnnee = [
    {
      TableRE_Code: '',
      TableRD_Champs: 'cof1',
      Lg_Code: '',
      TableRD_Des: 'Coeff 1° Pér',
      TableRD_Largeur: 100,
      TableRD_ReadOnly: true,
      TableRD_Format: '',
      TableRD_Alligement: 0,
      TableRD_Ordre: 2,
      TableRD_Type: 7,
      TableRD_Param1: null,
      TableRD_Param2: 'number',
      TableRD_ValDef: null,
      TableRD_Tri: true,
      TableRD_Valid: null,
      TableRD_ValidType: 0,
      TableRD_ExpressionH: null,
      TableRD_ExpressionR: null,
      User_Id: '*',
      User_Groupe: null,
    },
    {
      TableRE_Code: '',
      TableRD_Champs: 'moyenne1',
      Lg_Code: '',
      TableRD_Des: 'Moy 1° Pér',
      TableRD_Largeur: 100,
      TableRD_ReadOnly: true,
      TableRD_Format: '',
      TableRD_Alligement: 0,
      TableRD_Ordre: 3,
      TableRD_Type: 100,
      TableRD_Param1: null,
      TableRD_Param2: 'number',
      TableRD_ValDef: null,
      TableRD_Tri: true,
      TableRD_Valid: null,
      TableRD_ValidType: 0,
      TableRD_ExpressionH: null,
      TableRD_ExpressionR: null,
      User_Id: '*',
      User_Groupe: null,
    },
    {
      TableRE_Code: '',
      TableRD_Champs: 'cof2',
      Lg_Code: '',
      TableRD_Des: 'Coeff 2° Pér',
      TableRD_Largeur: 100,
      TableRD_ReadOnly: true,
      TableRD_Format: '',
      TableRD_Alligement: 0,
      TableRD_Ordre: 4,
      TableRD_Type: 0,
      TableRD_Param1: null,
      TableRD_Param2: 'number',
      TableRD_ValDef: null,
      TableRD_Tri: true,
      TableRD_Valid: null,
      TableRD_ValidType: 0,
      TableRD_ExpressionH: null,
      TableRD_ExpressionR: null,
      User_Id: '*',
      User_Groupe: null,
    },
    {
      TableRE_Code: '',
      TableRD_Champs: 'moyenne2',
      Lg_Code: '',
      TableRD_Des: 'Moy 2° Pér',
      TableRD_Largeur: 100,
      TableRD_ReadOnly: true,
      TableRD_Format: '',
      TableRD_Alligement: 0,
      TableRD_Ordre: 5,
      TableRD_Type: 0,
      TableRD_Param1: null,
      TableRD_Param2: null,
      TableRD_ValDef: null,
      TableRD_Tri: true,
      TableRD_Valid: null,
      TableRD_ValidType: 0,
      TableRD_ExpressionH: null,
      TableRD_ExpressionR: null,
      User_Id: '*',
      User_Groupe: null,
    },
    {
      TableRE_Code: '',
      TableRD_Champs: 'cloture',
      Lg_Code: '',
      TableRD_Des: 'Clôture',
      TableRD_Largeur: 70,
      TableRD_ReadOnly: true,
      TableRD_Format: '',
      TableRD_Alligement: 0,
      TableRD_Ordre: 9,
      TableRD_Type: 1,
      TableRD_Param1: null,
      TableRD_Param2: null,
      TableRD_ValDef: null,
      TableRD_Tri: true,
      TableRD_Valid: null,
      TableRD_ValidType: 0,
      TableRD_ExpressionH: null,
      TableRD_ExpressionR: null,
      User_Id: '*',
      User_Groupe: null,
    },
  ];
  //selected apprenant
  apprenant;

  //image selected apprenant
  imageAprenant = '../../assets/avatar.png';
  // groupe pour de l'apprenant selectionner
  groupe;

  //Année Scolaire  de l'apprenant selectionner
  AnneeScolaire;

  //periode  de l'apprenant selectionner
  periode;

  appreciation;
  listeCursus = [];
  listeMatiereCursus = [];
  listeAllMatiere = [];
  // liste colonne composon detail appreciation
  columnsDetailAppreciation = {
    TableRD: [
      {
        TableRE_Code: '',
        TableRD_Champs: 'matiere',
        Lg_Code: '',
        TableRD_Des: 'Matière',
        TableRD_Largeur: 150,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 1,
        TableRD_Type: 7,
        TableRD_Param1: null,
        TableRD_Param2: 'number',
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'formateur',
        Lg_Code: '',
        TableRD_Des: 'Formateurs',
        TableRD_Largeur: 150,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 2,
        TableRD_Type: 7,
        TableRD_Param1: null,
        TableRD_Param2: 'number',
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'min',
        Lg_Code: '',
        TableRD_Des: 'Min',
        TableRD_Largeur: 50,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 3,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: 'number',
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'max',
        Lg_Code: '',
        TableRD_Des: 'Max',
        TableRD_Largeur: 50,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 4,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'groupe',
        Lg_Code: '',
        TableRD_Des: 'Groupe',
        TableRD_Largeur: 100,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 5,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: 'number',
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'coeff',
        Lg_Code: '',
        TableRD_Des: 'Coeff',
        TableRD_Largeur: 50,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 6,
        TableRD_Type: 7,
        TableRD_Param1: null,
        TableRD_Param2: 'number',
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'moyenne',
        Lg_Code: '',
        TableRD_Des: 'Moyennes',
        TableRD_Largeur: 200,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 7,
        TableRD_Type: 100,
        TableRD_Param1: null,
        TableRD_Param2: 'number',
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: 'Moyenne Générale',
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
        valueTotal: 15.3,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'appreciation',
        Lg_Code: '',
        TableRD_Des: 'Appréciations matières',
        TableRD_Largeur: 300,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 8,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
    ],
  };

  listeGroupe = [];
  listePeriode = [];
  buttonDisabled: boolean = false;
  dateCreation;
  ngOnInit() {
    this.appreciation = {};
    this.getListeCursus();
    this.getListeAllMatiere();
    this.readParamUrl();
  }
  detail() {}
  init() {
    this.initialiserColonneTableau();
    this.initialiserTitre();
  }
  // initialiser le titre du fenettre
  initialiserTitre() {
    if (this.fenetre == '1') this.titre = 'APPRECIATION PAR MATIERE';
    if (this.fenetre == '2') this.titre = 'APPRECIATION PAR PERIODE';
    if (this.fenetre == '3') this.titre = 'APPRECIATION PAR ANNÉE SCOLAIRE';
  }
  // initialiser Colonne Tableau listeAppreciationComponen
  initialiserColonneTableau() {
    this.columnsAppreciation.TableRD = [];
    //appreciation par matière our par période
    if (this.fenetre == '1' || this.fenetre == '2') {
      this.columnsAppreciation.TableRD =
        this.columnsAppreciationMatierePeriode.filter(() => {
          return true;
        });
    }
    //appreciation par année
    else {
      this.columnsAppreciation.TableRD = [].concat(
        this.columnsAppreciationMatierePeriode
      );
      this.columnsAppreciation.TableRD =
        this.columnsAppreciationMatierePeriode.concat(
          this.columnsAppreciationAnnee
        );
      this.columnsAppreciation.TableRD =
        this.columnsAppreciation.TableRD.filter((col) => {
          return col.TableRD_Ordre != 6;
        });
    }
    setTimeout(() => {
      this.listeAppreciationComponen.setColonne(this.columnsAppreciation);
    }, 100);
  }
  onCursusChange(Cursus_Code) {
    if (this.listeAllMatiereIsLoadet == true) {
      this.generalService
        .rechercheTable(globalUrls.urlApplyCursusD + '&val=' + Cursus_Code)
        .subscribe((data) => {
          if (
            data.ApplyCursusD[0].Cursus_Code == null &&
            data.ApplyCursusD[0].Matiere_Code == null &&
            data.ApplyCursusD[0].CursusD_Id == null
          )
            data.ApplyCursusD = [];
          this.listeMatiereCursus = data.ApplyCursusD;
          this.generateListeMatiereCursus();
        });
    } else
      this.generalService.dialogSuccess(
        'Veuillez patienter pendant le chargement total des données',
        false
      );
  }
  generateListeMatiereCursus() {
    for (var i = 0; i < this.listeMatiereCursus.length; i++) {
      var matiere = this.listeAllMatiere.find((allMatiere) => {
        return (
          allMatiere.DiverSys_Index == this.listeMatiereCursus[i].Matiere_Code
        );
      });
      if (matiere != undefined) {
        this.listeMatiereCursus[i]['Matiere_Nom'] = matiere.DiverSys_Titre;
      }
    }
    this.listeMatiereCursus = this.generalService.sort(
      this.listeMatiereCursus,
      'Matiere_Nom'
    );
  }
  getListeAllMatiere() {
    this.generalService
      .rechercheTable(globalUrls.urlParametre + '&val=MAT01')
      .subscribe((data) => {
        this.listeAllMatiere = data.DiverSys;
        this.listeAllMatiereIsLoadet = true;
      });
  }
  getListeCursus() {
    this.generalService
      .rechercheTable(globalUrls.urlListeApplyCursus)
      .subscribe(
        (data) => {
          this.exist = true;
          this.listeCursus = this.generalService.sort(data, 'Cursus_Titre');
        },
        (error) => {
          this.exist = true;
        }
      );
  }
  clickBtnHeat(event) {
    switch (event.name) {
      case 'moyenne': {
        this.openDialogBulletinNotes(event.row);
        break;
      }
      case 'cloture': {
        break;
      }
    }
  }
  openDialogBulletinNotes(row) {
    var dialogConfig = new MatDialogConfig();
    this.generalService.dialog.open(
      AvtSuiviePedBulletinNotesComponent,
      dialogConfig
    );
  }
  imprimer() {}
  enregister() {}
  //open dialog Detail Appreciation
  openDetailAppreciation(frmDetailAppreciation) {
    var dialogConfig = new MatDialogConfig();
    this.generalService.dialog.open(frmDetailAppreciation, dialogConfig);
  }
  readParamUrl() {
    this.route.params.subscribe((params) => {
      this.fenetre = params['fenetre'];
      this.init();
    });
  }
}
